import React from "react";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { money, surfaceSx } from "./ownerCenterUi";

function Metric({ label, value, emphasis = false }) {
  return (
    <Box sx={{ minWidth: 0, px: { xs: .2, sm: .5 }, flex: { xs: "1 1 90px", sm: "0 1 auto" } }}>
      <Typography sx={{ color: "text.secondary", fontWeight: 850, fontSize: 10.5, lineHeight: 1.1 }}>{label}</Typography>
      <Typography noWrap sx={{ mt: .2, fontWeight: 1000, fontSize: { xs: 15.5, sm: 17.5 }, letterSpacing: "-.03em", color: emphasis ? "warning.main" : "text.primary" }}>{value}</Typography>
    </Box>
  );
}

export default function OwnerMoneyRealityStrip({ center, assistant, currency = "ARS", onCurrencyChange, onOpenFinance }) {
  const available = Number(center?.finance?.totalsByCurrency?.[currency] || 0);
  const outstanding = Number(center?.commercial?.outstandingByCurrency?.[currency] || 0);
  const recurringFloor = Number(assistant?.economy?.monthlyRecurringFloor || 0);
  const currencies = [...new Set([...(assistant?.currencies || []), currency])].filter(Boolean).slice(0, 3);

  return (
    <Box data-owner-jarvis-section="today-money" sx={{ ...surfaceSx, px: { xs: 1.15, sm: 1.4 }, py: .85 }}>
      <Stack direction="row" alignItems="center" spacing={{ xs: .7, sm: 1 }} sx={{ minWidth: 0 }}>
        <Typography sx={{ fontWeight: 1000, fontSize: 12.5, flexShrink: 0 }}>Dinero</Typography>
        <Divider orientation="vertical" flexItem />
        <Stack direction="row" alignItems="center" spacing={{ xs: .8, sm: 1.35 }} sx={{ minWidth: 0, flex: 1, overflowX: "auto", scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}>
          <Metric label="Disponible" value={money(available, currency)} />
          <Metric label="Por cobrar" value={money(outstanding, currency)} emphasis={outstanding > 0} />
          <Metric label="Base mensual" value={money(recurringFloor, currency)} />
        </Stack>
        <Stack direction="row" spacing={.15} alignItems="center" sx={{ flexShrink: 0 }}>
          {currencies.map((item) => (
            <Button key={item} size="small" variant={item === currency ? "contained" : "text"} onClick={() => onCurrencyChange?.(item)} sx={{ minWidth: 34, px: .5, borderRadius: 1.6, fontWeight: 1000, fontSize: 10.5 }}>{item}</Button>
          ))}
          <Button size="small" endIcon={<ArrowForwardRoundedIcon />} onClick={onOpenFinance} sx={{ display: { xs: "none", sm: "inline-flex" }, minWidth: 0, px: .5, textTransform: "none", fontWeight: 950 }}>Finanzas</Button>
        </Stack>
      </Stack>
    </Box>
  );
}
